import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import ContractDropdownItem from 'components/ContractDropdownItem';
import { languageStore, educationStore } from 'stores';
import { DropdownOptionInterface } from 'components/Forms/Dropdown';
import { currentStaffContractStore as store } from 'stores';
import { reaction, IReactionDisposer } from 'mobx';

interface Props {
    fieldState: FieldState<any>,
    editMode?: boolean
}

@observer class SelectEducation extends React.Component<Props> {

    reactionDisposer: IReactionDisposer | any;

    componentDidMount() {
        if (store.contract && store.contract.department) {
            const locationId = store.contract!.department.locationId;
            educationStore.getEducations(locationId);
        }

        this.reactionDisposer = reaction(() => store.currentLocationId, (locationId) => {
            if (!locationId) {
                educationStore.resetStore();
                return;
            }

            if (locationId && store.contract && 
                ((store.contract.department !== null && store.contract.department.locationId !== locationId) ||
                (store.contract && store.contract!.department === null))) {

                educationStore.getEducations(locationId!);
            }
        })
    }

    componentWillUnmount() {
        this.reactionDisposer();
    }

    render() {
        const { fieldState, editMode } = this.props;

        let opts: Array<DropdownOptionInterface> = [];
        educationStore.educations.forEach((education) => {
            opts.push({
                value: education.id,
                name: education.name
            })
        })

        return (
            <ContractDropdownItem
                label={languageStore.get('educationDetails')}
                id='educationDetails'
                placeholderText={languageStore.get('select')}
                fieldState={fieldState}
                options={opts}
                editMode={editMode} />
        )
    }

}

export default SelectEducation;